<div class="container dialog-container">
  <h2 class="display-6" *ngIf="data.isNew">Add Unloading</h2>
  <h2 class="display-6" *ngIf="!data.isNew">Edit Unloading</h2>

  <!-- Add / Edit Species -->
  <form [formGroup]="unloadingForm">
    <div class="row">
      <mat-form-field>
        <mat-label>Unloading Port</mat-label>
        <input matInput
               formControlName="unloadingPort"
               [matAutocomplete]="dept"
               required
               (focus)="clearUnloadingPort()" />
        <mat-autocomplete #dept="matAutocomplete"
                          [displayWith]="displayFn"
                          (optionSelected)="onOptionSelected()">
          <mat-option *ngFor="let option of filteredPorts | async"
                      [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
        <!-- Error Messages for Unloading Port -->
        <mat-error *ngIf="unloadingForm.get('unloadingPort')?.hasError('required')">
          Unloading port is required.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field>
        <mat-label>Unloading Date</mat-label>
        <input matInput
               readonly
               formControlName="unloadingDate"
               (click)="openDateDialog()"
               required />
        <!-- Error Messages for Unloading Date -->
        <mat-error *ngIf="unloadingForm.get('unloadingDate')?.hasError('required')">
          Unloading date is required.
        </mat-error>
        <mat-error *ngIf="unloadingForm.get('unloadingDate')?.hasError('minDate')">
          Date must be on or after
          {{
            unloadingForm.get('unloadingDate')?.errors?.minDate.requiredDate
              | date: 'shortDate'
          }}.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="add-species-button">
      <button mat-fab
              class="text-button"
              type="button"
              aria-label="Add Species"
              (click)="addSpecies(unloadingSpecies.length)">
        Add Species
      </button>
    </div>

    <div class="row">
      <table mat-table [dataSource]="unloadingSpecies" class="mat-elevation-z8">
        <!-- Species Column -->
        <ng-container matColumnDef="species">
          <th mat-header-cell *matHeaderCellDef> Species </th>
          <td mat-cell *matCellDef="let sp">
            <div style="display: flex; flex-direction: row; justify-content: space-between;">
              {{ sp.speciesName }}
            </div>
          </td>
        </ng-container>

        <!-- Pounds Landed Column -->
        <ng-container matColumnDef="poundsLanded">
          <th mat-header-cell *matHeaderCellDef> Pounds Landed </th>
          <td mat-cell *matCellDef="let sp">
            <div style="display: flex; flex-direction: row; justify-content: space-between;">
              <span>{{ (sp.poundsLanded | number) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Landing Receipt Column -->
        <ng-container matColumnDef="landingReceipt">
          <th mat-header-cell *matHeaderCellDef> Landing Receipt </th>
          <td mat-cell *matCellDef="let sp">
            <div style="display: flex; flex-direction: row; justify-content: space-between;">
              {{ sp.landingReceipt }}
            </div>
          </td>
        </ng-container>

        <!-- Header and Data Rows -->
        <tr mat-header-row *matHeaderRowDef="unloadingSpeciesColumns"></tr>
        <tr mat-row
            (click)="addSpecies(index)"
            *matRowDef="
            let row;
            columns: unloadingSpeciesColumns;
            let index = index
          "></tr>
      </table>
    </div>
  </form>

  <!-- Delete Button -->
  <div class="top-right" *ngIf="!data.isNew">
    <button mat-mini-fab
            type="button"
            class="blue-icon-button"
            style="background-color: var(--elog-button-face); color: var(--elog-button-face-text)"
            aria-label="Delete Unloading"
            (click)="deleteUnloading()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>

  <!-- Bottom Buttons-->
  <div class="buttons" style="padding-top: 20px;">
    <button mat-fab
            class="text-blue-button"
            type="button"
            aria-label="Back"
            (click)="closeDialog()">
      Cancel
    </button>

    <button mat-fab
            class="text-button"
            type="button"
            aria-label="Add Unloading"
            (click)="addUnloading()">
      OK
    </button>
  </div>
</div>
